import { createQueryKeys } from '@lukemorales/query-key-factory';

export const agentContracts = createQueryKeys('agentContracts', {
  list: (scope: string, agentProfileId: string) => [scope, agentProfileId],
});
